import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when an office clicks the active "Next" button on the "Shift Details"
 * step of the OLD Shift Request flow
 * Event: dental_portal:shift_request:shift_details_submitted
 */
export function fireV0ShiftDetailsSubmitted(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:shift_details_submitted', {
    version: 202401,
  });
}
